export default "__VITE_ASSET__Dx4iLk7G__"